// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const disabled = "PaginatorArrow__disabled__BgRL2";
export const double = "PaginatorArrow__double__jR7Bs";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const paginatorArrow = "PaginatorArrow__paginatorArrow__JocD8";
export const regular = "400";
export const right = "PaginatorArrow__right__qxfXy";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const strokes = "PaginatorArrow__strokes__0clKm";